<template>
    <div class="card">
        <!-- :resizableColumns="true" -->
        <DataTable
            v-model:first="offset"
            :rows="numberOfRows"
            :multiSortMeta="preSort"

            :value="allDebriefs"
            :lazy="true"
            :paginator="true"
            ref="dt"
            dataKey="id"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage($event)"
            @sort="onSort($event)"
            sortMode="multiple"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries — Page No: {currentPage} of {totalPages}"
        >
            <template #empty> No {{ label('Debriefs') }} available. </template>
            <template #loading> Loading {{ label('Debriefs') }}. Please wait. </template>
            <Column field="id" header="ID" style="width: 4rem">
                <template #body="slotProps">
                    <span class="p-column-title">ID</span>
                    {{ slotProps.data.id }}
                </template>
            </Column>
            <Column field="incident_number" header="INCIDENT NO" sortable style="width: 8rem">
                <template #body="slotProps">
                    <span class="p-column-title">INCIDENT NO</span>
                    {{ slotProps.data.incident?.incident_number }}
                </template>
            </Column>
            <Column field="incident" :header="`${label('Debrief').toUpperCase()} TYPE`" style="width: 10rem">
                <template #body="slotProps">
                    <span class="p-column-title">{{ label('Debrief').toUpperCase() }} TYPE</span>
                    {{ slotProps.data.incident_category?.toUpperCase() }}
                </template>
            </Column>
            <Column field="incident_date" header="DATE" sortable style="width: 8rem" />
            <Column field="created_at" header="CREATED" sortable style="width: 8rem" />

            <Column field="author" header="AUTHOR"  style="width: 10rem" >
                <template #body="slotProps">
                    <span class="p-column-title">AUTHOR</span>
                    {{ slotProps.data.author?.name }}
                    {{ slotProps.data.author?.surname }}
                </template>
            </Column>

            <Column field="learning_outcome" header="LEARNING OUTCOME" style="width: 25rem" :emptyMessage="'No Learning Outcomes'">
                <template #body="slotProps">
                    <span class="p-column-title">LEARNING OUTCOME</span>
                    <div v-if="slotProps.data.learning_outcome && slotProps.data.learning_outcome.length > 0">
                        <debrief-learning-outcomes-panel :learnings="slotProps.data.learning_outcome" />
                    </div>
                    <div v-else>
                        <span v-if="slotProps.data.learning == 1">Learning outcome not yet created</span>
                        <span v-else>Learning not identified</span>
                    </div>
                </template>
                <template #empty> No Learning Outcomes </template>
            </Column>
            <Column field="exercise_name" header="EXERCISE NAME" sortable style="width: 8rem" >
                <template #body="slotProps">
                    {{ slotProps.data?.incident?.exercise_name ?? '' }}
                </template>
            </Column>


            <Column field="actions" header="ACTIONS" style="width: 11rem">
                <template #body="slotProps">
                  <span class="p-column-title">ACTIONS</span>
                    <Button v-if="authStore.hasPermission(UserPermission.READ_DEBRIEF)" icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" @click="viewDebrief(slotProps.data.id)" v-tooltip="`View ${label('Debrief')}`" />
                    <Button v-if="
                        authStore.hasPermission(UserPermission.WRITE_DEBRIEF) || slotProps.data.author_id === authStore.loggedUserId
                        " icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editDebrief(slotProps.data.id)"
                        v-tooltip="`Edit ${label('Debrief')}`"
                    />
                    <Button v-if="authStore.hasPermission(UserPermission.DELETE_DEBRIEF)" icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmRequest({ id: slotProps.data.id }, deleteDebrief, 'delete')" v-tooltip="`Delete ${label('Debrief')}`" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import DebriefLearningOutcomesPanel from '../modules/DebriefLearningOutcomesPanel.vue';
import { storeToRefs } from 'pinia';
import { computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { authStore, debriefStore } from '@/store/global-stores';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();
import { UserPermission } from '@/modules/permission/enum';
import NProgress from 'nprogress';
import { useConfirmRemove } from '@/composables/ConfirmComposable';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import {
    getOrder,
    buildPagination,
    getPage,
    getPerPage,
    setOrder,
    setPage,
    setPerPage,
} from '@/composables/PaginationComposable';

const { allDebriefs, loading, totalRecords, params } = storeToRefs(debriefStore);
const router = useRouter();
const { confirmRequest } = useConfirmRemove();

const tableListCode = 'debriefList'

const loadAllWithProgress = async () => {
    NProgress.start();
    await loadDebriefs();
    NProgress.done();
};

const offset = computed({
    get() {
        return getPage(tableListCode) * getPerPage(tableListCode)
    },
    set(first) {
        const rows = getPerPage(tableListCode)
        setPage(tableListCode, Math.floor(first / rows))
    }
})

const numberOfRows = computed(() => {
    return getPerPage(tableListCode)
})

const preSort = computed(() => {
    const order = getOrder(tableListCode)
    order.forEach((sort) => {
        console.log('sort', sort.field, sort.order);
    })



    return order
})

onMounted(async () => {
    buildPagination(tableListCode, 0, 10, [{field: 'created_at', order: -1}])

    await loadAllWithProgress();
});

const loadDebriefs = async () => {
    await debriefStore.fetchAllDebriefs(tableListCode);
};

onUnmounted(() => {
    debriefStore.initparams();
});

const onPage = (event) => {
    params.value = event;
    setPage(tableListCode, event.page)
    setPerPage(tableListCode, event.rows)
    loadDebriefs();
};

const onSort = (event) => {
    setPage(tableListCode, 0)
    setOrder(tableListCode, event.multiSortMeta)
    loadDebriefs();
};

const editDebrief = (id) => {
    //console.log('id', id)
    router.push({ name: 'DebriefCreateUpdate', query: { debriefId: id } });
};

const viewDebrief = (id) => {
    router.push({ name: 'DebriefDetails', params: { id } });
};

const deleteDebrief = async (id) => {
    console.log('id', id);

    let deleteUrl = process.env.VUE_APP_API_VERSION + '/debrief/' + id + '?companyId=' + authStore.getLoggedUserCompanyId;

    try {
        const response = await authApi.delete(deleteUrl);
        if (response.statusCode === 200) {
            await loadAllWithProgress();
        }
    } catch (error) {
        await showToast({}, error?.data?.message ?? 'Failed to delete the debrief');
    }
};
</script>
